import { render, staticRenderFns } from "./HelpNav.vue?vue&type=template&id=0b06470a"
import script from "./HelpNav.vue?vue&type=script&lang=js"
export * from "./HelpNav.vue?vue&type=script&lang=js"
import style0 from "./HelpNav.vue?vue&type=style&index=0&id=0b06470a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports